
import '../App.css';
import Header from '../components/Header';
import Publication from "../components/Publication";
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <Publication/>
    
    <Footer/>
    </div>
  );
}

export default App;
